/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react"
import { CircularProgress } from "@material-ui/core"
import Swal from "sweetalert2"

import { i18n } from "../../translate/i18n"

import "./style.css"

import { ToastContainer } from "react-toastify"
import { useAuth } from "hooks/auth"
import ForgotPassword from "./ForgotPassword"

export default function Login({ history }) {
  const [login, setLogin] = useState({ user: "", password: "" })
  const [loading, setLoading] = useState(false)
  const { user, signIn } = useAuth()
  const [forgotPassword, setForgotPassword] = useState(false)

  useEffect(() => {
    if (user) {
      history.push("/dashboard")
    }
  }, [])

  const handleConfirm = async (event) => {
    event.preventDefault()
    setLoading(true)

    try {
      await signIn({ login: login.user, password: login.password })
      const user = JSON.parse(sessionStorage.getItem("@Omni:user"))
      history.push(
        user.startPage === "/" ? "/dashboard" : `/dashboard${user.startPage}`
      )
      // window.open(window.location, "_self","location=no,toolbar=no,scrollbars=yes,resizable=yes,width=");
      // window.close();
      setLoading(false)
    } catch (error) {
      Swal.fire({
        title: "Erro",
        text:
          (error && error.message) ??
          "An unexpected error has occurred, contact support.",
        icon: "warning",
        confirmButtonText: "Ok",
      })
      setLoading(false)
    }
  }

  const handleInputChange = (e) => {
    const { name, value } = e.target

    setLogin({ ...login, [name]: value })
  }

  return (
    <>
      <ToastContainer autoClose={3000} />
      {!forgotPassword ? (
        <div className="bg-login-page">
          <div className="container-login">
            <div className="login-content first-content ">
              <div className="first-column-login">
                <h2 className="title">{i18n.t("welcomeHeader")}</h2>
                <div className="logo">
                  <img
                    className="img-logo"
                    src="assets/images/logo-omni.png"
                    alt="logo"
                  />
                </div>
              </div>

              <div className="second-column-login">
                <h1 className="title-login">{i18n.t("loginHeader")}</h1>
                <form className="form-login">
                  <div className="input-form-login">
                    <input
                      type="text"
                      placeholder={i18n.t("login")}
                      required
                      name="user"
                      onChange={handleInputChange}
                      style={{ paddingLeft: 15 }}
                    />
                  </div>
                  <div className="input-form-login">
                    <input
                      type="password"
                      autoComplete="off"
                      placeholder={i18n.t("password")}
                      required
                      value={login.password || ""}
                      name="password"
                      onChange={handleInputChange}
                      style={{ paddingLeft: 15 }}
                    />
                  </div>
                  <div className="box-btn-login">
                    <>
                      {!loading ? (
                        <button className="btn-login" onClick={handleConfirm}>
                          {i18n.t("login")}
                        </button>
                      ) : (
                        <div className="area-loading-login">
                          <CircularProgress />
                        </div>
                      )}
                    </>
                  </div>
                  <div
                    style={{ cursor: "pointer", marginTop: 20 }}
                    onClick={() => setForgotPassword(true)}
                  >
                    <p>{i18n.t("forgotPassword")}</p>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <ForgotPassword setForgotPassword={setForgotPassword} />
      )}
    </>
  )
}
